<template>
    <v-list
        class="scroll-updater-main-container"
        >
        <v-list-item
            v-scroll="scrollTopOverDetect"
            v-for="item in items"
            color="#ffffff"
            :key="item.title"
            :class="item.className"
            :to="{ name: 'Ui', params: { id: item.id } }"
            >
            <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
                <div class="list-item-value"
                     v-text="item.valueWithDesc"></div>
            </v-list-item-content>
            <v-list-item-icon
                v-if="item.inAlarm"
                >
                <v-icon class="keyframe-show-hide-all"
                        v-if="item.inAlarm"
                        color="pink"
                        style='padding-top: 15px'
                        >
                    mdi-bell-alert
                </v-icon>
            </v-list-item-icon>
            <v-list-item-icon>
                <UiImageCond
                    :uiId="item.id"
                    :value="''+item.value"
                    :size="30"
                    />
            </v-list-item-icon>
        </v-list-item>
    </v-list>
</template>

<script>
    import axios from "axios";
    import { EventBus } from "@/event-bus";
    import { functions } from "../functions";
    import { sort } from "fast-sort";
    import { appCaller } from "../mixins/appCaller";
    import { scrollUpdater } from "../mixins/scrollUpdater";
    import UiImageCond from "./UiImageCond";

    export default {
        name: "UiList",

        mixins: [scrollUpdater, appCaller],

        components: {
            UiImageCond
        },

        props: {
            msg: String,
        },

        data: function () {
            return {
                items: [],
                poiId: this.$route.params.poiId
            };
        },

        created: function () {
            EventBus.$emit("eventPageLoad", {
                name: "Unidades de informação L" + this.$updNowLevels.level1,
            });
        },

        mounted: function () {
            //Ação do usuário que dispara evento de atualização.
            EventBus.$on("scrollTopOverDetect", function () {
                this.appCallerDispatchEventByLevel(this.$updNowLevels.level1);
            }.bind(this));

            //Atualiza informações da tela quando evento for disparado.
            this.appCallerListenEventByLevel(this.$updNowLevels.level1, function () {
                this.loadList();
            }.bind(this));
        },

        beforeDestroy: function () {
        },

        afterCreate: function () {},

        beforeCreate: function () {},

        methods: {
            loadList: function () {
                console.log("UiList::loadList");    
                EventBus.$emit("eventWaitingStart");
                const apiRoot = process.env.VUE_APP_ROOT_API;
                const url = apiRoot + "/ui/list/" + this.poiId + "/1";
                axios
                        .get(url, axios.getHeaders())
                        .then((response) => {
                            console.log(response.data);
                            this.createList(response.data);
                        })
                        .catch((err) => {
                            return functions.parseCatch(err, this.$appMessages.err404);
                        })
                        .finally(() => {
                            EventBus.$emit("eventWaitingEnd");
                        });
            },

            makeValue: function (elem) {
                return `${elem.value} (${elem.tag})`;
            },

            makeItem: function (elem) {
                return {
                    icon: true,
                    id: elem.id,
                    title: elem.title,
                    tag: "TAG" + elem.tag,
                    value: elem.value,
                    valueWithDesc: this.makeValue(elem),
                    inAlarm: elem.inAlarm,
                    className: elem.inAlarm ? "-keyframe-danger" : "",
                    avatar: "",
                };
            },

            createList: function (uis) {
                uis.map((elem) => {
                    if (!elem.showInInfowindow) {
                        return;
                    }
                    this.updateItem(elem);
                });

                this.items = sort(this.items).asc([(i) => i.title]);
            },

            updateItem: function (itemNew) {
                const itemCurrent = this.getItem(itemNew.id);
                if (itemCurrent === false) {
                    return this.items.push(this.makeItem(itemNew));
                }
                itemCurrent.value = itemNew.value;
                itemCurrent.valueWithDesc = this.makeValue(itemNew);

                //if (itemCurrent.value == "-97"){
                //    itemCurrent.inAlarm = 1;
                //}
            },

            getItem: function (id) {
                for (let i in this.items) {
                    const item = this.items[i];
                    if (item.id == id) {
                        return item;
                    }
                }
                return false;
            }
        },
    };
</script>

<style scoped>
    .list-item-value {
        color: #999999;
        font-size: 12px;
    }

    .v-list-item__title {
        color: #666666;
        font-size: 13px;
    }
</style>
